(ns client-portal.client.smart-ordering.tags.data
  (:require [client-portal.client.concepts.data :as concepts.d]
            [shared.core.reactive :as re]
            [shared.core.util :as util]))

(def by-concept-id-path [:smart-ordering :tags :by-concept-id])

(re/reg-auth0-loader
  :so-tags/load-list
  (fn [[concept-id]]
    (conj by-concept-id-path concept-id))
  (fn [_ concept-id]
    {:method :post
     :url "/api/so/tags/list"
     :json-params {:concept-id concept-id}})
  :transf (fn [resp]
            (or (some-> resp :body (util/->kebab-case-keywords))
                {}))
  :error-transf (fn [] {})
  :quiet-fail? true)

(re/reg-sub
  :so-tags/list-by-current-concept-id-
  (fn [db]
    (let [concept-id (concepts.d/current-concept-id db)
          v (get-in db (conj by-concept-id-path concept-id))]
      (if (and concept-id (nil? v))
        (re/dispatch-load [:so-tags/load-list concept-id])
        v))))
